import React, { Component } from 'react';
import CaspianDatePicker from '../../../Elements/InputComponents/BaseInputs/CaspianDatePicker';
import ColButton from '../../../Elements/ColButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import InfoBox from '../../../Elements/InfoBox';
import Loading from '../../../Elements/loading';
import OverWindow from '../../../Elements/OverWindow';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import mathHelper from '../../../Helpers/mathHelper';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import PIPlannedAssignmentsMultiEditSubPanel from './PIPlannedAssignmentsMultiEditSubPanel';
import TimeSpanAdjuster from './TimeSpanAdjuster';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';

class PIMultiEditBox extends Component {
  static timespan = '';
  constructor(props) {
    super(props);
    const nopd =
      typeof props.numberOfPlanningDetails === 'undefined' || props.numberOfPlanningDetails < 1
        ? 1
        : props.numberOfPlanningDetails;
    this.state = {
      numberOfEvalsPerCycle:
        typeof props.numberOfEvalsPerCycle === 'undefined' || props.numberOfEvalsPerCycle < 0
          ? 0
          : props.numberOfEvalsPerCycle,
      numberOfPlanningDetails: nopd,
      startDates: null,
      endDates: null,
      applyDateRow: null,
      subpanelValues: null,
      loading: true,
    };
    PIMultiEditBox.timespan = this.getTimeSpan(nopd);
  }

  GetApplyDateRowDefaultValue(selectedCountries) {
    for (let i = 1; i < selectedCountries.length; i++) {
      if (selectedCountries[i].startDate !== selectedCountries[0].startDate) {
        return false;
      }
    }
    return true;
  }

  componentDidMount() {
    this.populatePlanningDetailsData();
  }

  async populatePlanningDetailsData() {
    const idList = this.props.selectedCountries.map((sc) => sc.pricingId);
    PlanningDetailsItemService.GetPlanningDetailsDatesByPricingIds(idList)
      .then((result) => {
        const applyDateRowDefaultValue = this.GetApplyDateRowDefaultValue(result);
        this.setState({
          startDates: this.generateStartDates(this.state.numberOfPlanningDetails, applyDateRowDefaultValue, result),
          endDates: this.generateEndDates(this.state.numberOfPlanningDetails, applyDateRowDefaultValue, result),
          applyDateRow: this.generateApplyDateRowArray(this.state.numberOfPlanningDetails, applyDateRowDefaultValue),
          loading: false,
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('PMEB68'));
  }

  getTimeSpan(nopd) {
    switch (nopd) {
      case 52:
        return 'weekly';
      case 12:
        return 'monthly';
      case 6:
        return 'bimonthly';
      case 4:
        return 'quarterly';
      case 1:
        return 'yearly';
      default:
        return 'other';
    }
  }

  timeSpanAdjusterOnChange(fieldname) {
    PIMultiEditBox.timespan = fieldname;
  }

  generateApplyDateRowArray(numberOfPlanningDetails, defaultValue) {
    const arr = new Array(numberOfPlanningDetails);
    return arr.fill(defaultValue);
  }

  generateStartDates(numberOfPlanningDetails, useDefaultValue, selectedCountries) {
    const today = new Date();
    const twelveYearsAgo = new Date(new Date().getFullYear() - 20, new Date().getMonth(), new Date().getDate());
    const tempStartDates = [];
    for (let i = 0; i < numberOfPlanningDetails; i++) {
      tempStartDates[i] =
        useDefaultValue && selectedCountries[i].startDate > twelveYearsAgo
          ? selectedCountries[i].startDate
          : this.addDays(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12, 0, 0), i);
    }
    return tempStartDates;
  }

  generateEndDates(numberOfPlanningDetails, useDefaultValue, selectedCountries) {
    const today = new Date();
    const twelveYearsAgo = new Date(new Date().getFullYear() - 20, new Date().getMonth(), new Date().getDate());

    const tempEndDates = [];
    for (let i = 0; i < numberOfPlanningDetails; i++) {
      tempEndDates[i] =
        useDefaultValue && selectedCountries[i].endDate > twelveYearsAgo
          ? selectedCountries[i].endDate
          : this.addDays(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12, 0, 0), i);
    }
    return tempEndDates;
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  renderApplyCheckBox(indexOfRow) {
    return (
      <td
        className='border-0'
        key='applytr'
      >
        <input
          type='checkbox'
          checked={this.state.applyDateRow[indexOfRow]}
          onChange={(e) => {
            const tempArray = [...this.state.applyDateRow];
            tempArray[indexOfRow] = e.target.checked;
            this.setState({
              applyDateRow: tempArray,
            });
          }}
        />
      </td>
    );
  }

  adjustDatesByTimeSpan(tempStartDates, tempEndDates, indexOfRow, type) {
    let monthsToAdd;
    let first;
    let year;
    let month;
    let day;

    if (type === 'StartDate') {
      for (let i = 0; i < tempStartDates.length; i++) {
        switch (PIMultiEditBox.timespan) {
          case 'weekly':
            if (i > 0) {
              tempStartDates[i] = this.addDays(tempStartDates[i - 1], 7);
            }
            tempEndDates[i] = this.addDays(tempStartDates[i], 6);
            break;

          case 'monthly':
            monthsToAdd = 1;
            if (i > 0) {
              first = new Date(tempStartDates[i - 1]);
              tempStartDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate());
            }
            first = new Date(tempStartDates[i]);
            tempEndDates[i] = new Date(
              first.getFullYear(),
              first.getMonth() + monthsToAdd,
              first.getDate() - 1,
              12,
              0,
              0
            );
            break;

          case 'bimonthly':
            monthsToAdd = 2;
            if (i > 0) {
              first = new Date(tempStartDates[0]);
              tempStartDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd * i, first.getDate());

              first = new Date(tempEndDates[0]);
              year = first.getFullYear();
              month = first.getMonth() + monthsToAdd * i;
              day = first.getDate();
              if (day >= 28) day = 31;
              day = dateTimeHelper.LimitDayNumber(year, month, day);

              tempEndDates[i] = new Date(year, month, day);
            } else {
              first = new Date(tempStartDates[0]);
              tempEndDates[0] = new Date(
                first.getFullYear(),
                first.getMonth() + monthsToAdd,
                first.getDate() - 1,
                12,
                0,
                0
              );
            }
            break;

          case 'quarterly':
            monthsToAdd = 3;
            if (i > 0) {
              first = new Date(tempStartDates[0]);
              tempStartDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd * i, first.getDate());

              first = new Date(tempEndDates[0]);
              year = first.getFullYear();
              month = first.getMonth() + monthsToAdd * i;
              day = first.getDate();
              if (day >= 28) day = 31;
              day = dateTimeHelper.LimitDayNumber(year, month, day);

              tempEndDates[i] = new Date(year, month, day);
            } else {
              first = new Date(tempStartDates[0]);
              tempEndDates[0] = new Date(
                first.getFullYear(),
                first.getMonth() + monthsToAdd,
                first.getDate() - 1,
                12,
                0,
                0
              );
            }
            break;

          case 'yearly':
            monthsToAdd = 12;
            if (i > 0) {
              first = new Date(tempStartDates[i - 1]);
              tempStartDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate());
            }
            first = new Date(tempStartDates[i]);
            tempEndDates[i] = new Date(
              first.getFullYear(),
              first.getMonth() + monthsToAdd,
              first.getDate() - 1,
              12,
              0,
              0
            );
            break;

          default:
            break;
        }
      }
    } else {
      for (let i = 1; i < tempEndDates.length; i++) {
        switch (PIMultiEditBox.timespan) {
          case 'weekly':
            tempEndDates[i] = this.addDays(tempEndDates[i - 1], 7);
            break;

          case 'monthly':
            monthsToAdd = 1;
            first = new Date(tempEndDates[i - 1]);
            tempEndDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate(), 12, 0, 0);
            break;

          case 'bimonthly':
            monthsToAdd = 2;
            first = new Date(tempEndDates[0]);
            year = first.getFullYear();
            month = first.getMonth() + monthsToAdd * i;
            day = first.getDate();
            if (day >= 28) day = 31;
            day = dateTimeHelper.LimitDayNumber(year, month, day);
            tempEndDates[i] = new Date(year, month, day);
            break;

          case 'quarterly':
            monthsToAdd = 3;
            first = new Date(tempEndDates[0]);
            year = first.getFullYear();
            month = first.getMonth() + monthsToAdd * i;
            day = first.getDate();
            if (day >= 28) day = 31;
            day = dateTimeHelper.LimitDayNumber(year, month, day);
            tempEndDates[i] = new Date(year, month, day);
            break;

          case 'yearly':
            monthsToAdd = 12;
            first = new Date(tempEndDates[i - 1]);
            tempEndDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate(), 12, 0, 0);
            break;

          default:
            break;
        }
      }
    }
  }

  adjustDates(tempStartDates, tempEndDates, indexOfRow, type) {
    const base = type === 'StartDate' ? tempStartDates[indexOfRow] : tempEndDates[indexOfRow];
    if (indexOfRow === 0 && PIMultiEditBox.timespan !== 'other') {
      this.adjustDatesByTimeSpan(tempStartDates, tempEndDates, indexOfRow, type);
    } else {
      for (let i = 0; i < tempStartDates.length; i++) {
        if (i < indexOfRow) {
          if (tempStartDates[i] > base) tempStartDates[i] = base;
          if (tempEndDates[i] > base) tempEndDates[i] = base;
        }

        if (i === indexOfRow) {
          if (type === 'StartDate') {
            if (tempEndDates[i] < base) tempEndDates[i] = base;
          } else if (tempStartDates[i] > base) tempStartDates[i] = base;
        }

        if (i > indexOfRow) {
          if (tempStartDates[i] < base) tempStartDates[i] = base;
          if (tempEndDates[i] < base) tempEndDates[i] = base;
        }
      }
    }
  }

  renderDateRows() {
    const rows = [];

    for (let i = 0; i < this.state.numberOfPlanningDetails; i++) {
      rows.push(
        <tr
          className='border hover'
          key={`dateRowTr${i}`}
        >
          <td
            className='border-0'
            key='periodTr'
          >
            {`Period ${i + 1}`}
          </td>
          {this.renderApplyCheckBox(i)}
          <td
            className='border-0'
            key='startDateTr'
          >
            <CaspianDatePicker
              selected={this.state.startDates[i]}
              labelText={''}
              onChange={(e) => {
                const tempStartDates = this.state.startDates;
                tempStartDates[i] = e;
                const tempEndDates = this.state.endDates;
                this.adjustDates(tempStartDates, tempEndDates, i, 'StartDate');
                this.setState({
                  startDates: tempStartDates,
                  endDates: tempEndDates,
                });
              }}
            />
          </td>
          <td
            className='border-0'
            key='endDateTr'
          >
            <CaspianDatePicker
              selected={this.state.endDates[i]}
              labelText={''}
              onChange={(e) => {
                const tempStartDates = this.state.startDates;
                const tempEndDates = this.state.endDates;
                tempEndDates[i] = e;
                this.adjustDates(tempStartDates, tempEndDates, i, 'EndDate');
                this.setState({
                  startDates: tempStartDates,
                  endDates: tempEndDates,
                });
              }}
            />
          </td>
        </tr>
      );
    }

    return rows;
  }

  isAllApplyDateRowSelected() {
    for (const element of this.state.applyDateRow) {
      if (!element) {
        return false;
      }
    }
    return true;
  }

  SelectOrDeselectAllApplyDateRow() {
    const allSelected = this.isAllApplyDateRowSelected();
    const tempArray = [...this.state.applyDateRow];
    for (let i = 0; i < tempArray.length; i++) {
      tempArray[i] = !allSelected;
    }
    this.setState({ applyDateRow: tempArray });
  }

  PlannedAssignmentsSubpanelOnChangeHandler(subpanelValues) {
    const result = [];
    for (let i = 0; i < subpanelValues.shopCounts.length; i++) {
      result.push({
        pricingId: subpanelValues.pricingIds[i],
        numberOfPlannedAssignments: subpanelValues.shopCounts[i],
        applyTargetRate: subpanelValues.applyValues[i],
        targetAssignmentRate: subpanelValues.targetAssignmentRates[i],
        targetCompletionRate: subpanelValues.targetCompletionRates[i],
      });
    }
    this.setState({ subpanelValues: result });
  }

  renderTableHeadCell(text) {
    const allSelected = this.isAllApplyDateRowSelected();
    return (
      <th className='border-0'>
        {text === 'Apply' ? (
          <span
            className='pointer'
            onClick={() => this.SelectOrDeselectAllApplyDateRow()}
          >
            Apply ({allSelected ? 'Des' : 'S'}elect all)
          </span>
        ) : (
          text
        )}
      </th>
    );
  }

  renderTableHead() {
    return (
      <thead className='border-0'>
        <tr>
          {this.renderTableHeadCell('Fieldwork Period')}
          {this.renderTableHeadCell('Apply')}
          {this.renderTableHeadCell('Start Date')}
          {this.renderTableHeadCell('End Date')}
        </tr>
      </thead>
    );
  }

  renderChangesWillBeAppliedInTheseCountries() {
    let countryList = '';
    const rotated = this.props.selectedCountries.length > 10 ? '' : '+';
    if (this.props.selectedCountries.length > 0)
      countryList = this.props.selectedCountries.map((c) => c.country).join(', ');
    const infotext =
      this.props.selectedCountries.length > 0 ? (
        <>
          Planning Details in Status 'Cancelled' and 'Closed' will not be updated.
          <br />
          <br />
          It will be applied on the following countr{this.props.selectedCountries.length > 1 ? 'ies' : 'y'}:
          <br />
          {this.props.selectedCountries.length > 0 ? countryList : 'None'}
        </>
      ) : (
        'There is no selected country.'
      );
    return (
      <InfoBox
        text={infotext}
        rotated={rotated}
      />
    );
  }

  formIsOkay() {
    if (this.state.subpanelValues === null) return true;
    if (this.state.subpanelValues.find((sv) => sv.numberOfPlannedAssignments === 0) !== undefined) return false;
    if (
      this.state.subpanelValues.find(
        (n) =>
          n.applyTargetRate &&
          (mathHelper.Sum(n.targetAssignmentRate) !== 100 || mathHelper.Sum(n.targetCompletionRate) !== 100)
      ) !== undefined
    )
      return false;
    return true;
  }

  showNotification() {
    const innerText = this.state.applyDateRow.find((e) => e) ? ' and fieldwork start and end dates' : '';
    ErrorMessage.SetApprove(`You are going to update planned shop counts${innerText}.`, () =>
      this.props.submitHandler(
        this.state.applyDateRow,
        this.state.startDates,
        this.state.endDates,
        this.state.subpanelValues
      )
    );
  }

  renderContent() {
    return (
      <div className='d-flex justify-content-center align-items-start m-1'>
        <div className='text-center'>
          <TimeSpanAdjuster
            checked={PIMultiEditBox.timespan}
            onChange={this.timeSpanAdjusterOnChange}
          />
          <div className='d-flex justify-content-center m-1'>
            <table className='border-0 w-75'>
              {this.renderTableHead()}
              <tbody>{this.renderDateRows()}</tbody>
            </table>
            {/* {this.renderChangesWillBeAppliedInTheseCountries()} */}
          </div>
          <PIPlannedAssignmentsMultiEditSubPanel
            selectedCountries={this.props.selectedCountries}
            onChange={this.PlannedAssignmentsSubpanelOnChangeHandler.bind(this)}
          />

          <ButtonFooterContainer>
            <ColButton
              text='Cancel'
              onClick={this.props.clickOnCancel}
            />
            <ColButton
              text='Save'
              disabled={!this.formIsOkay()}
              onClick={() => {
                this.showNotification();
                // this.props.submitHandler(this.state.applyDateRow, this.state.startDates,this.state.endDates, this.state.subpanelValues);
              }}
              icon='fa-solid fa-save'
            />
          </ButtonFooterContainer>
        </div>
        {this.renderChangesWillBeAppliedInTheseCountries()}
      </div>
    );
  }

  render() {
    return (
      <OverWindow
        headerText='Edit Multiple Planning Items'
        clickOnCancel={this.props.clickOnCancel}
        iconName='fa-solid fa-edit'
        title='MultiEdit'
        closeOnClickOutside={false}
      >
        {this.state.loading ? <Loading /> : this.renderContent()}
      </OverWindow>
    );
  }
}

export default PIMultiEditBox;
